var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var SvgUnrealizedIncome = function SvgUnrealizedIncome(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.215,
    height: 21.214,
    viewBox: "0 0 21.215 21.214",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69873",
    "data-name": "Group 69873",
    transform: "translate(0 -0.011)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69872",
    "data-name": "Group 69872",
    transform: "translate(0 0.011)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_34257",
    "data-name": "Path 34257",
    d: "M21.091,8.889A1.867,1.867,0,0,0,20.669,6.9L14.322.556a1.867,1.867,0,0,0-2.637,0L4.55,7.692H1.865A1.867,1.867,0,0,0,0,9.557v9.8a1.867,1.867,0,0,0,1.865,1.865H19.351a1.867,1.867,0,0,0,1.865-1.865v-9.8A1.854,1.854,0,0,0,21.091,8.889Zm-1.35-1.156a1.864,1.864,0,0,0-.391-.041H18l.848-.848ZM17.973,5.965,16.246,7.692H14.488l2.606-2.606ZM12.564,1.435a.622.622,0,0,1,.879,0l2.772,2.772L12.73,7.692H6.308Zm7.408,17.926a.622.622,0,0,1-.622.622H1.865a.622.622,0,0,1-.622-.622v-9.8a.622.622,0,0,1,.622-.622H19.351a.622.622,0,0,1,.622.622Z",
    transform: "translate(0 -0.011)",
    fill: "#8d8db5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34258",
    "data-name": "Path 34258",
    d: "M59,406.585h2.9v1.243H59Z",
    transform: "translate(-56.555 -389.738)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34259",
    "data-name": "Path 34259",
    d: "M167.032,406.585h2.9v1.243h-2.9Z",
    transform: "translate(-160.111 -389.738)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34260",
    "data-name": "Path 34260",
    d: "M275.065,406.585h2.9v1.243h-2.9Z",
    transform: "translate(-263.667 -389.738)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34261",
    "data-name": "Path 34261",
    d: "M383.1,406.585h2.9v1.243h-2.9Z",
    transform: "translate(-367.223 -389.738)",
    fill: "#ffd45d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34262",
    "data-name": "Path 34262",
    d: "M63.16,255.372H61.036A1.037,1.037,0,0,0,60,256.408v1.657a1.037,1.037,0,0,0,1.036,1.036H63.16a1.037,1.037,0,0,0,1.036-1.036v-1.657A1.037,1.037,0,0,0,63.16,255.372Zm-.207,2.486h-1.71v-1.243h1.71Z",
    transform: "translate(-57.514 -244.791)",
    fill: "#8d8db5"
  })))));
};

export default SvgUnrealizedIncome;